import { defineAction, object } from '~/prix'
import sendAttendanceUrgencyAlertEmail from './sendAttendanceUrgencyAlertEmail.action.json'

const sendAttendanceUrgencyAlertEmailDefinition = defineAction({
  ...sendAttendanceUrgencyAlertEmail,
  input: object({}),
  output: object({}),
})

export default sendAttendanceUrgencyAlertEmailDefinition

